export function debounce(func, timeout = 400) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
}

export function closeOnOutsideClick(selector, subselector = null) {
    selector = document.querySelector(selector);
    document.addEventListener('click', (event) => {
        const withinBoundaries = event.composedPath().includes(selector);
        if (!withinBoundaries) {
            if (subselector) {
                selector.querySelector(subselector).classList.remove('active');
            } else {
                selector.classList.remove('active');
            }
        }
    });
}

export function randomIntFromInterval(min, max) { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min);
}